import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppEntities } from "src/config/entities";
import { WriteOffGoodsDto } from "../dtos/WriteOffGoodsDto";
import { WriteOffGoodsModel } from "../models/WriteOffGoodsModel";
import { WriteOfGOodsService } from "src/services/documents/WriteOffGoodsService";
import { WriteOffGoodsProductDto } from "../dtos/WriteOffGoodsProductDto";

interface IProps {
  documentId?: string;
}

export const useFetchWriteOfGoods = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<WriteOffGoodsDto | null>(null);
  const [documentModel, setDocumentModel] = useState<WriteOffGoodsModel | null>(null);
  const dataService = AppEntities.WriteOffGoods.getDataService() as WriteOfGOodsService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: WriteOffGoodsModel) => {
    if (!documentId) return;
    console.log(documentModel);
    const requestDto: WriteOffGoodsDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      console.log("documentId", documentId);

      let responseDto: WriteOffGoodsDto | null = null;
      let responseProductDto: WriteOffGoodsProductDto[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: WriteOffGoodsModel = {
        ...responseDto,
        products: [...responseProductDto]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
